"use client"

import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "@/shared/ui/dialog"

import { Button, Text } from "@chakra-ui/react"
import { useTranslations } from "next-intl"

interface IDialog {
  isWarning?: boolean
  isOpen: boolean
  onClose: () => void
  title?: string
  onConfirm: () => void
  description?: string
  closeOnConfirm?: boolean
  text?: { confirm?: string; cancel?: string }
  children?: React.ReactNode
  size?: "xs" | "sm" | "md" | "lg" | "xl"
}

export default function ConfirmModal({
  isWarning,
  isOpen,
  onClose,
  title,
  onConfirm,
  description,
  closeOnConfirm = true, // stupid solution, but when dialogs sequentially closed, a bug occuring.
  text = {
    confirm: "yes",
    cancel: "no",
  },
  size = "xs",
  children,
}: IDialog) {
  const t = useTranslations()

  return (
    <DialogRoot
      size={size}
      id="confirmation"
      placement={"center"}
      motionPreset="slide-in-bottom"
      open={isOpen}
      onOpenChange={onClose}
    >
      <DialogContent borderRadius="20px" mx={4}>
        <DialogHeader justifyContent="center">
          <DialogTitle color={"text"} textAlign={"center"}>
            {title}
          </DialogTitle>
        </DialogHeader>
        {(children || description) && (
          <DialogBody color={"text"}>
            <Text textAlign="center">{description}</Text>
            {children}
          </DialogBody>
        )}

        <DialogFooter justifyContent="center" px={4}>
          {text.cancel && (
            <Button
              variant={"subtle"}
              rounded={16}
              size="xl"
              onClick={onClose}
              flex={1}
            >
              {t(text.cancel)}
            </Button>
          )}
          {text.confirm && (
            <Button
              size="xl"
              rounded={16}
              bg={isWarning ? "red.500" : "primary"}
              onClick={() => {
                onConfirm()
                if (closeOnConfirm) {
                  onClose()
                }
              }}
              flex={1}
            >
              {t(text.confirm)}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  )
}
